import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import { useBrandedImages } from '../../hooks/useBranding';

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const { loginLogo } = useBrandedImages();

    useEffect(() => {
        const mq = window.matchMedia('(max-width: 767px)');
        const apply = () => {
            const mobile = mq.matches;
            setIsMobile(mobile);
            setSidebarOpen(!mobile);
        };
        apply();
        mq.addEventListener('change', apply);
        return () => mq.removeEventListener('change', apply);
    }, []);

    const closeMobileSidebar = () => {
        if (isMobile) setSidebarOpen(false);
    };

    return (
        <div className="flex h-screen md:h-[calc(100vh-20px)] min-h-0 rounded-lg w-100 relative">
            {/* Mobile overlay */}
            {isMobile && sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-40 md:hidden"
                    onClick={() => setSidebarOpen(false)}
                    aria-hidden="true"
                />
            )}

            <Sidebar
                isOpen={sidebarOpen}
                setIsOpen={setSidebarOpen}
                isMobile={isMobile}
                onNavigate={closeMobileSidebar}
            />

            <div className="flex-1 bodymainbg min-w-0 flex flex-col overflow-hidden">
                {/* Mobile top bar — same loginLogo asset, natural aspect ratio */}
                <div className="md:hidden flex items-center gap-3 px-3 py-2.5 bg-[#1A232D] shrink-0">
                    <button
                        type="button"
                        onClick={() => setSidebarOpen(true)}
                        className="p-2 rounded-md text-white hover:bg-gray-600 transition-colors shrink-0"
                        aria-label="Open menu"
                    >
                        <Menu className="w-6 h-6" />
                    </button>
                    {loginLogo && (
                        <div className="bg-white rounded-[10px] px-3 py-1.5 flex items-center justify-center shrink-0">
                            <img
                                src={loginLogo}
                                alt="Company Logo"
                                className="h-10 w-auto max-w-[220px] object-contain block"
                            />
                        </div>
                    )}
                </div>

                <div className="flex-1 min-h-0 p-2 md:p-4 md:pt-0 md:pb-0 md:pr-0 overflow-hidden">
                    <div className="contentbg h-full overflow-y-auto overflow-x-hidden">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
